export { CoreMenuCollectionPage } from './collection';
